import { render, staticRenderFns } from "./_freee.vue?vue&type=template&id=982d8a82&"
import script from "./_freee.vue?vue&type=script&lang=js&"
export * from "./_freee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports